module.exports = __webpack_public_path__ + "img/arabic.b2f20d9.png";